import React from "react";
import { Toast, Result } from "@ad/anq-ui";
import { CopyToClipboard } from "react-copy-to-clipboard";
import styles from "./ErrorUi.module.scss";
import Empty from "components/empty";

/** 出错时的展示 */
export default function ErrorUi(props) {
  const { copyStr } = props;

  return (
    <Empty
      title="系统出现错误"
      className="h-[calc(100vh-56px)]"
      image={<Result status={500} className="mb-[-16px]" />}
      content={[
        <span key={1}>
          请复制事件 ID 提供给对接的商家客服或招商小二，方便定位问题
        </span>,
        <div key={2}>
          事件ID：{copyStr}
          <CopyToClipboard
            text={copyStr}
            onCopy={() => Toast.success("复制成功")}
          >
            <a className={styles["copy-text"]}>复制</a>
          </CopyToClipboard>
        </div>,
      ]}
    />
  );
}
